<template lang="pug">
  ul.space-y-5
    li(v-for="(headerLink, index) in headerLinks")
      a.flex.items-start(
        href="#"
        @click="scrollToSection($event, headerLink.id)"
      )
        span.rounded-full.h-10.w-10.inline-flex.items-center.justify-center.flex-shrink-0(
          :class="[isCurrentSection(headerLink.id) ? activeCounterClass : counterClass]"
        ) {{ index + 1 }}
        span.ml-5.leading-tight(
          :class="[linkClass, isCurrentSection(headerLink.id) ? activeLinkClass : '']"
        ) {{ headerLink.value }}
</template>

<script>
import { smoothScroller } from '../../mixins/smoothScroller';

export default {
  name: 'SwTableOfContents',
  mixins: [smoothScroller],
  props: {
    initialRawData: {
      type: String,
      default: null,
    },
    counterClass: {
      type: String,
      default: '',
    },
    activeCounterClass: {
      type: String,
      default: '',
    },
    linkClass: {
      type: String,
      default: '',
    },
    activeLinkClass: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      headerLinks: JSON.parse(this.initialRawData),
      currentSection: null,
    };
  },
  mounted () {
    window.addEventListener('scroll', this.currentSectionInViewport);
    // We append to the DOM the external Embedly library that is needed to
    // display embeded external contents added in the text contents with
    // Contentful web interface, following their documentation:
    // https://www.contentful.com/help/markdown/#embed-media-content-with-embedly
    // https://docs.embed.ly/v1.0/docs/platformjs
    const externalScript = document.createElement('script');
    externalScript.setAttribute('async', '');
    externalScript.setAttribute('src', '//cdn.embedly.com/widgets/platform.js');
    externalScript.setAttribute('charset', 'UTF-8');
    document.head.appendChild(externalScript);
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.currentSectionInViewport);
  },
  methods: {
    currentSectionInViewport () {
      this.headerLinks.forEach(link => {
        const section = document.getElementById(link.id);
        const sectionPosition = section.getBoundingClientRect().top;
        if (sectionPosition > 0 && sectionPosition < 150) {
          this.currentSection = link.id;
        }
      });
    },
    isCurrentSection (id) {
      return (this.currentSection === id);
    },
    scrollToSection ($event, id) {
      $event.preventDefault($event);
      const section = document.getElementById(id);
      const navbarOffset = 110;

      this.smoothScrollToElement(section, navbarOffset);
    },
  },
};
</script>
